import { useSyncExternalStore } from 'react';

const subscribe = (changed: () => void) => {
  window.addEventListener('online', changed);
  window.addEventListener('offline', changed);
  return () => {
    window.removeEventListener('online', changed);
    window.removeEventListener('offline', changed);
  };
};

/**
 * Whether the device has network now (round 2: offline content plays its
 * kept copy without it). Read again once subscribed, so a change between
 * the first render and the subscription is never missed.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}
